<template>
  <span>
    <ViewCsv v-if="props.display === 'csv'" :data="data" :space="props.space" />
    <span v-else class="list-view">
      <span v-for="item in data" :key="item">
        <SmartLink v-if="item.uri" :to="item.uri"> {{ item.title }} </SmartLink>
        <span v-else> {{ item.title }}</span>
      </span>
    </span>
  </span>
</template>

<script setup>
const props = defineProps({
  display: { type: String, default: "csv" },
  space: { type: Boolean, default: false },
});
const page = inject("page");

const findNodeByUri = nodes => {
  let foundNode = null;
  nodes.forEach(node => {
    return node.uri === `/${unref(page).uri}` && node.url === null
      ? (foundNode = node)
      : node.children && !foundNode && node.url !== null
      ? (foundNode = findNodeByUri(node.children))
      : null;
    // if (node.uri === `/${unref(page).uri}` && node.url === null) {
    //   foundNode = node;
    //   return foundNode;
    // } else if (node.children && !foundNode && node.url !== null) {
    //   foundNode = findNodeByUri(node.children);
    // }
  });
  return foundNode;
};

const getChildrenByUri = nodes => {
  const node = findNodeByUri(nodes);
  return node ? (node.children ? node.children : []) : [];
};
const data = ref(getChildrenByUri(unref(page)?.structurizer));
</script>
